import React, {PropTypes} from 'react';
import CONSTANTS from '../common_constants';
import {getDateTime} from '../util/common';
import classNames from 'classnames';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import shipmentActions from './shipment_actions';
import $ from 'jquery';

class ShipperProgressBar extends React.Component{
    constructor(props){
      super(props);
      const shipment = props.shipment && props.shipment.shipmentDetails;
      this.state = {
        shipment
      }
      this.getShipperStatusInfo = this.getShipperStatusInfo.bind();
    }

    componentWillReceiveProps(newProps){
      this.setState({"shipment":newProps.shipment.shipmentDetails});
    }

    getShipperStatusInfo(shipment){

      let transportation;
      const onMyWayDateObj = !shipment.onMyWayDateTime ? getDateTime(shipment.deliveryDateTime || shipment.deliveryDate) : getDateTime(shipment.onMyWayDateTime);
      const arrivedAtDestnObj =  shipment.arrivedAtDestinationDateTime ? getDateTime(shipment.arrivedAtDestinationDateTime) : '';
      const deliveredDateObj = shipment.deliveredDate ? getDateTime(shipment.deliveredDate) : '';

      let pickupDateObj;
      if (shipment.shipmentStatus >=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && shipment.actualPickUpTime) {
        pickupDateObj = getDateTime(shipment.actualPickUpTime);
      }
      else if(shipment.shipmentStatus===CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && shipment.pickupDateTime){
        pickupDateObj = getDateTime(shipment.pickupDateTime);
      }

      let deliveryDateObj;
      if (shipment.shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION && shipment.deliveryDateTime) {
        deliveryDateObj = getDateTime(shipment.deliveryDateTime);
      }
      else if(shipment.shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION && shipment.arrivedAtDestinationDateTime){
        deliveryDateObj = getDateTime(shipment.arrivedAtDestinationDateTime);
      }

      const transportType = CONSTANTS.carrierTransportType[shipment.carrierTransportType];
      if(transportType==="flight") transportation = transportType + " #" + shipment.flightNo;
      if(transportType==="car") transportation = transportType + " :" + shipment.carInfo.make + ", " + shipment.carInfo.model+ ", " + shipment.carInfo.color;
      if(transportType==="public transport") transportation = transportType + " #" + shipment.publicTransitInfo;

      let recipientImages;

      if(shipment.recipientImages && shipment.recipientImages.length>0) recipientImages =  shipment.recipientImages;
      else if(shipment.recipientImg) { let images = []; images.push(shipment.recipientImg) ; recipientImages = images;};

      return({
        pickupLocation: shipment.pickupLocation,
        pickupDate: pickupDateObj ? pickupDateObj.date : '',
        pickupTime: pickupDateObj ? pickupDateObj.time : '',
        deliveryDate: deliveryDateObj ? deliveryDateObj.date : '',
        deliveryTime: deliveryDateObj ? deliveryDateObj.time : '',
        transportation,
        secretCode: shipment.secretCode,
        deliveryLocation: shipment.deliveryLocation,
        handoffItemImages: shipment.handoffItemImages,
        recipientImages: recipientImages,
        shipmentStatus: shipment.shipmentStatus,
        onMyWayDate: onMyWayDateObj ? onMyWayDateObj.date : '',
        onMyWayTime: onMyWayDateObj ? onMyWayDateObj.time : '',
        arrivedDestnDate: arrivedAtDestnObj ? arrivedAtDestnObj.date : '',
        arrivedDestnTime: arrivedAtDestnObj ? arrivedAtDestnObj.time : '',
        deliveredDate: deliveredDateObj ? deliveredDateObj.date : '',
        deliveredTime: deliveredDateObj ? deliveredDateObj.time : '',
        isShipper: shipment.isShipper
      })
    }

    render(){
      const { props, state } = this;
      const { pickupLocation, pickupDate,
              pickupTime, transportation,
              deliveryLocation, handoffItemImages,
              secretCode, deliveryDate,isShipper,
              deliveryTime, recipientImages, shipmentStatus,
              onMyWayDate, onMyWayTime, arrivedDestnDate,
              arrivedDestnTime, deliveredDate, deliveredTime
            } = this.getShipperStatusInfo(state.shipment);

      return(
        <div className = "progress-bar">
          <div className = "progress-steps-wrap">
            <div className = "connector"></div>
            <div className = "progress-steps">
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  &&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                shipmentStatus >=CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE  &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED })} >Carrier Handoff
                <span className = "step-info desktopHide">
                  <span className = "location pickup-location">{pickupLocation}</span>
                  {
                    handoffItemImages && handoffItemImages.length > 0 &&
                      <span className = "handoff-img-wrp img-wrp">
                        {
                          handoffItemImages.map( (imgSrc, idx) => {
                            return(
                              <img className = "handoff-img" src = {imgSrc} key = {idx} />
                            )
                          })
                        }
                      </span>
                  }
                </span>
              </span>
              <span className = "step-info responsiveHide">
                <span className = "location pickup-location">{pickupLocation}</span>
                {
                  handoffItemImages && handoffItemImages.length > 0 &&
                    <span className = "handoff-img-wrp img-wrp">
                      {
                        handoffItemImages.map( (imgSrc, idx) => {
                          return(
                            <img className = "handoff-img" src = {imgSrc} key = {idx} />
                          )
                        })
                      }
                    </span>
                }
              </span>
              <span className = "step-info">
                <span className = "time-info date">{pickupDate}</span>
                {
                  pickupTime && <span className = "time-info">
                    <span className = "icon-clock clock-img"></span> {pickupTime}
                  </span>
                }
              </span>
            </div>
          </div>
          {/* Arrived at destination*/}
          <div className = "progress-steps-wrap on-the-way-wrap">
            <div className = "connector"></div>
            <div className = "progress-steps">
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  &&
                  <span className = "circle"></span>
              }
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE  &&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY   &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE })}>Carrier Flight to {deliveryLocation}
                <span className = "step-info desktopHide">
                  <span className = "transport-info ">{transportation}</span>
                </span>
              </span>
              <span className = "step-info responsiveHide">
                <span className = "transport-info">{transportation}</span>
              </span>
            </div>
            {
              shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY  &&
                <div className = "progress-steps on-the-way">
                  <span className = "sub-step-inprogress"></span>

                  <span className = "step-name sub-step-name">Carrier on the way</span>
                  <span className = "step-info sub-step-info">
                    <span className = "time-info date">{onMyWayDate}</span>
                    {
                      onMyWayTime && <span className = "time-info">
                        <span className = "icon-clock clock-img"></span> {onMyWayTime}
                      </span>
                    }
                  </span>
                </div>
            }
            {
              shipmentStatus >CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY &&
                <div className = "progress-steps arrived-destn">
                  <span className = "sub-step-inprogress"></span>

                  <span className = "step-name sub-step-name">Carrier arrived at delivery location {deliveryLocation}</span>
                  <span className = "step-info sub-step-info">
                    { arrivedDestnDate && <span className = "time-info date">{arrivedDestnDate}</span> }
                    {
                      arrivedDestnTime && <span className = "time-info">
                        <span className = "icon-clock clock-img"></span> {arrivedDestnTime}
                      </span>
                    }
                  </span>
                </div>
            }
          </div>
          {/* Meets reciepent*/}
          <div className = "progress-steps-wrap">
            <span className = "connector"></span>
            <div className = "progress-steps ">
              {
                ( shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY) &&
                  <span className = "circle"></span>
              }
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION &&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION })}>Carrier Meets with Recipient
                <span className = "step-info desktopHide">
                  <span className = "location delivery-location">{deliveryLocation}</span>
                    {
                      recipientImages && recipientImages.length > 0 &&
                        <span className = "recipient-img-wrp img-wrp">
                          {
                            recipientImages.map( (imgSrc, idx) => {
                              return(
                                <img className = "recipient-img" src = {imgSrc} key = {idx} />
                              )
                            })
                          }
                        </span>
                    }
                </span>
              </span>
              <span className = "step-info responsiveHide">
                <span className = "location delivery-location">{deliveryLocation}</span>
                {
                  recipientImages && recipientImages.length > 0 &&
                    <span className = "recipient-img-wrp img-wrp">
                      {
                        recipientImages.map( (imgSrc, idx) => {
                          return(
                            <img className = "recipient-img" src = {imgSrc} key = {idx} />
                          )
                        })
                      }
                    </span>
                 }
              </span>
            {
                shipmentStatus != CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <span className = "step-info">
                <span className = "time-info date">{deliveryDate}</span>
                {
                  deliveryTime && <span className = "time-info">
                    <span className = "icon-clock clock-img"></span> {deliveryTime}
                  </span>
                }
              </span>
            }
            </div>
          </div>
          {/*---------- Delivery Completed --------------------*/}
          <div className = "progress-steps-wrap">
            {
              ( shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED ||
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE ||
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY ||
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION ) &&
                <span className = "circle"></span>
            }
            {
              shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT &&
                <span className = "outer-circle">
                  <span className = "circle inner-circle"></span>
                </span>
            }
            {
              shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED &&
                <span className = "outer-circle step-completed">
                  <span className = "icon-check check-img"></span>
                </span>
            }
            <div className = "progress-steps ">
              <span className =  {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT})}>Delivery Confirmation
                { isShipper && <span className = "step-info desktopHide">Give Code <span className = "secret-code">{secretCode}</span> to recipient. Carrier will need this code to confirm delivery.</span>}
              </span>
              { isShipper && <span className = "step-info responsiveHide">Give Code  <span className = "secret-code">{secretCode}</span> to recipient. Carrier will need this code to confirm delivery.</span>}
              {
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <span className = "step-info">
                  <span className = "time-info date delivery-confirmation">{deliveredDate}
                  <span className = "time-info">
                    <span className = "icon-clock clock-img"></span> {deliveredTime}
                  </span>
                </span>
                </span>
              }
            </div>
          </div>
        </div>
      )
    }
}


ShipperProgressBar = connect((state) => {
  return {
    shipment: state.app.shipment,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(ShipperProgressBar);

module.exports = ShipperProgressBar;



// WEBPACK FOOTER //
// app/shipment/shipper_progress_bar.jsx